import { snakeStore, SORT_COLUMN, SORT_DIRECTION } from '@app/plugins/vuex-async-pagginate';
import { NotificationService } from '@notify/services/NotificationService';

export default snakeStore(
  {
    actions: {
      getData: (_, params) => NotificationService.getList(params),
      readAllServer: ({ dispatch }) =>
        dispatch('notify/notifications/last/readAll', {}, { root: true })
    },

    state: {
      [SORT_COLUMN]: 'created_at',
      [SORT_DIRECTION]: 'desc'
    }
  },
  true
);
